(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ENDPOINT = ROOT + 'cart/update.js';

  /**
   * Send a discount value to the cart. Empty string clears all discounts.
   * Returns the updated cart JSON.
   */
  function postDiscount(discount) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: discount })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart update failed');
      return r.json();
    });
  }

  /** Is the given code present and applicable in the returned cart? */
  function isApplicable(cart, code) {
    var list = (cart && cart.discount_codes) || [];
    var target = code.trim().toLowerCase();
    for (var i = 0; i < list.length; i += 1) {
      if (list[i].code && list[i].code.toLowerCase() === target) {
        return list[i].applicable === true;
      }
    }
    return false;
  }

  /** Ask the theme to re-render the cart (subtotal, discount line, header count). */
  function refreshCart() {
    document.dispatchEvent(
      new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
    );
  }

  /** Reflect the applied code (or none) across every discount field on the page. */
  function syncState(code) {
    document.querySelectorAll('discount-code-field').forEach(function (el) {
      var appliedRow = el.querySelector('[data-applied-row]');
      var display = el.querySelector('[data-code-display]');
      var input = el.querySelector('[data-discount-input]');
      if (code) {
        if (display) display.textContent = code.toUpperCase();
        if (appliedRow) appliedRow.hidden = false;
        if (input) input.value = '';
      } else if (appliedRow) {
        appliedRow.hidden = true;
      }
      el.dataset.appliedCode = code || '';
    });
  }

  function showError(el, show) {
    var err = el.querySelector('[data-error]');
    if (err) err.hidden = !show;
  }

  function setBusy(el, busy) {
    var btn = el.querySelector('[data-apply-btn]');
    if (!btn) return;
    btn.disabled = busy;
    btn.textContent = busy ? 'Applying…' : 'Apply';
  }

  function apply(el) {
    var input = el.querySelector('[data-discount-input]');
    var code = input ? input.value.trim() : '';
    if (!code) return;

    var previous = el.dataset.appliedCode || '';
    showError(el, false);
    setBusy(el, true);

    postDiscount(code)
      .then(function (cart) {
        if (isApplicable(cart, code)) {
          syncState(code);
          refreshCart();
          return null;
        }
        // Invalid: undo (restore the previously valid code, or clear), then warn.
        return postDiscount(previous).then(function () {
          syncState(previous);
          showError(el, true);
          refreshCart();
        });
      })
      .catch(function () {
        // Network / server error: try to restore prior state and warn.
        return postDiscount(previous)
          .then(function () {
            syncState(previous);
          })
          .catch(function () {})
          .then(function () {
            showError(el, true);
            refreshCart();
          });
      })
      .then(function () {
        setBusy(el, false);
      });
  }

  function remove(el) {
    showError(el, false);
    postDiscount('')
      .then(function () {
        syncState('');
        refreshCart();
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function init() {
    document.querySelectorAll('discount-code-field:not([data-init])').forEach(function (el) {
      el.setAttribute('data-init', '');
      var applyBtn = el.querySelector('[data-apply-btn]');
      var removeBtn = el.querySelector('[data-remove-btn]');
      var input = el.querySelector('[data-discount-input]');

      if (applyBtn) applyBtn.addEventListener('click', function () { apply(el); });
      if (removeBtn) removeBtn.addEventListener('click', function () { remove(el); });
      if (input) {
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') { e.preventDefault(); apply(el); }
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('on:cart:after-merge', init);
  if (document.readyState !== 'loading') init();
})();
